import { lazy } from "react";

/**
 * Igual que React.lazy, pero se recupera de los `ChunkLoadError` que ocurren
 * cuando se publica una nueva versión y el navegador del usuario tiene en caché
 * referencias a chunks antiguos que ya no existen.
 *
 * En ese caso recarga la página UNA vez (con guarda en sessionStorage para evitar
 * bucles de recarga). Sin esto, cada navegación fallida generaría un error en bucle
 * que inunda el reporte de errores.
 */
const RELOAD_KEY = "tf_chunk_reload";

export function lazyWithReload(factory) {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY); // carga exitosa: permitir futuras recuperaciones
      return mod;
    } catch (err) {
      const msg = String(err?.message || err);
      const isChunkError =
        /Loading chunk|ChunkLoadError|dynamically imported module|Failed to fetch dynamically|Importing a module script failed/i.test(msg);
      if (isChunkError && !sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        return { default: () => null }; // placeholder mientras recarga
      }
      throw err;
    }
  });
}
